import { graphql } from 'gql.tada';

export const GET_CATEGORIES = graphql(`
    query GetCategories($language: LanguageISOCode!) {
        categories(language: $language) {
            identifier {
                sku
                id
            }
            titles
            catchPhrases
            image
        }
    } 

`);
